import { baseQuery } from '../baseQuery';

import env from 'env';

export type BedrockApiResponse = {
  answer: string;
  session_id?: string | null;
  next_action: {
    type?: string;
    payload?: {
      title?: string;
      phone?: string;
      customerID?: string;
      jobID?: string;
      url?: string;
      msg?: string;
    };
  };
  citations?: Array<{
    retrievedReferences?: Array<{
      content?: { text?: string };
      metadata?: {
        title?: string;
        url?: string;
        category?: string;
      };
    }>;
  }>;
  error?: string;
};

export type PostKnowledgebasePayload = {
  query: string;
  session_id: string | null;
  customer_ID?: string;
};

export const postKnowledgebase = async (payload: PostKnowledgebasePayload): Promise<BedrockApiResponse> => {
  return await baseQuery('knowledgebase', {
    type: 'POST',
    body: payload,
    api: env.AI_API_SERVER
  });
};
